export const FeatureFlags = [
  "show_maintenance_screen",
  "show_maintenance_banner",
  "workflow_summary_2",
  "enable_redux_logger",
  "enable_deal_finder_ads",
] as const;
